import { CmsStaticPageDetail } from '../../../../components/Cms';

export function CmsStaticPageDetails() {
  return <CmsStaticPageDetail />;
}
